module.exports = __webpack_public_path__ + "media/images/checkmark-8182ddab856a311c42a071042a561b7e.svg";